/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Absenceseriesid2Inputs */

const en_entity_absenceseriesid2 = /** @type {(inputs: Entity_Absenceseriesid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absence Series ID`)
};

const de_entity_absenceseriesid2 = /** @type {(inputs: Entity_Absenceseriesid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abwesenheitsserien-ID`)
};

/**
* | output |
* | --- |
* | "Absence Series ID" |
*
* @param {Entity_Absenceseriesid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_absenceseriesid2 = /** @type {((inputs?: Entity_Absenceseriesid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Absenceseriesid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_absenceseriesid2(inputs)
	return de_entity_absenceseriesid2(inputs)
});
export { entity_absenceseriesid2 as "entity_absenceSeriesId" }